import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_YOUTUBE_DATA = `${API_URL}/api/v1/parent/activity`;
export const DELETE_YOUTUBE_DATA = `${API_URL}/api/v1/parent/delete-activity`;
export const BLOCK_UNBLOCK = `${API_URL}/api/v1/parent/channel`;
export const GET_COUNT = `${API_URL}/api/v1/parent/video-activity-count`;

export function getYouTubeData(payload) {
  return axiosInstance({
    url: GET_YOUTUBE_DATA,
    method: "GET",
    params: payload,
  });
}

export function deleteYouTubeData(payload) {
  return axiosInstance({
    url: DELETE_YOUTUBE_DATA,
    method: "POST",
    data: payload,
  });
}

export function blockUnblockYouTubeData(payload) {
  return axiosInstance({
    url: BLOCK_UNBLOCK,
    method: "POST",
    data: payload,
  });
}

export function getCountYouTubeData(payload) {
  return axiosInstance({
    url: GET_COUNT,
    method: "GET",
    params: payload,
  });
}
